import { MessageTick } from 'iconsax-react';
import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import Helpers from '../../../../lib/helpers';

//FIXME : UNcomment here please !!
type Props = {
  read: boolean;
  timestamp: string;
  myMessage?: boolean;
};

const MessageStatus = ({ read, timestamp, myMessage }: Props) => {
  const { t } = useTranslation();
  const formattedTime = Helpers.formatTime(
    Helpers?.convertUTCToUserLocal?.(timestamp)
  );

  return (
    <div
      className={cn(
        'flex gap-1 text-xs text-text-secondary dark:text-dark-text-secondary',
        {
          'justify-end': myMessage,
          'justify-start': !myMessage,
        }
      )}
      data-testid="chat-message-status"
    >
      <span>{formattedTime}</span>
      {myMessage && (
        <span className="flex items-center gap-1">
          <MessageTick size={12} /> |{' '}
          <span>{read ? t('seen') : t('unseen')}</span>
        </span>
      )}
    </div>
  );
};

export default MessageStatus;
